import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { LiveChat } from "./components/LiveChat";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import IndustriesPage from "./pages/IndustriesPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import RecruitmentPage from "./pages/RecruitmentPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import QualityPolicyPage from "./pages/QualityPolicyPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App min-h-screen bg-ink-900 text-slate-100">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/recruitment" element={<RecruitmentPage />} />
            <Route path="/careers" element={<RecruitmentPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/quality-policy" element={<QualityPolicyPage />} />
          </Routes>
        </main>
        <Footer />
        <LiveChat />
        <Toaster
          position="bottom-left"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(15, 17, 23, 0.95)",
              border: "1px solid rgba(6, 182, 212, 0.3)",
              color: "white",
              backdropFilter: "blur(16px)",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
